[
 {
  "id": "frozen-dune",
  "name": "Frozen Dune",
  "kind": "full",
  "refs": [
   "frozen-dune-2.jpg",
   "frozen-dune-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-frozen-dune-pzybm/",
  "thumb": "/styles/frozen-dune.jpg",
  "colorDescription": "frozen dune: pale ash blonde with white and light grey strands"
 },
 {
  "id": "frozen-dune-con-waves",
  "name": "Frozen Dune con Waves",
  "kind": "full",
  "refs": [
   "frozen-dune-con-waves-1.jpg",
   "frozen-dune-con-waves-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-frozen-dune/",
  "thumb": "/styles/frozen-dune-con-waves.jpg",
  "colorDescription": "frozen dune: pale ash blonde with white and light grey strands, wavy"
 },
 {
  "id": "ivory-dune",
  "name": "Ivory Dune",
  "kind": "full",
  "refs": [
   "ivory-dune-2.jpg",
   "ivory-dune-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-ivory-dune-1w03l/",
  "thumb": "/styles/ivory-dune.jpg",
  "colorDescription": "ivory dune: ivory cream blonde with sandy beige tones"
 },
 {
  "id": "ivory-dune-con-waves",
  "name": "Ivory Dune con Waves",
  "kind": "full",
  "refs": [
   "ivory-dune-con-waves-1.jpg",
   "ivory-dune-con-waves-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-ivory-dune-195p2/",
  "thumb": "/styles/ivory-dune-con-waves.jpg",
  "colorDescription": "ivory dune: ivory cream blonde with sandy beige tones, wavy"
 },
 {
  "id": "tidal-sand",
  "name": "Tidal Sand",
  "kind": "full",
  "refs": [
   "tidal-sand-2.jpg",
   "tidal-sand-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-tidal-sand-t66y1/",
  "thumb": "/styles/tidal-sand.jpg",
  "colorDescription": "tidal sand: sandy beige blonde with pale blue-grey strands"
 },
 {
  "id": "tidal-sand-con-waves",
  "name": "Tidal Sand con Waves",
  "kind": "full",
  "refs": [
   "tidal-sand-con-waves-1.jpg",
   "tidal-sand-con-waves-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-tidal-sand-1hjm1/",
  "thumb": "/styles/tidal-sand-con-waves.jpg",
  "colorDescription": "tidal sand: sandy beige blonde with pale blue-grey strands, wavy"
 },
 {
  "id": "rose-sand",
  "name": "Rose Sand",
  "kind": "full",
  "refs": [
   "rose-sand-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-rose-sand-1qz87/",
  "thumb": "/styles/rose-sand.jpg",
  "colorDescription": "rose sand: dusty rose pink mixed with sandy blonde"
 },
 {
  "id": "rose-sand-con-waves",
  "name": "Rose Sand con Waves",
  "kind": "full",
  "refs": [
   "rose-sand-con-waves-1.jpg",
   "rose-sand-con-waves-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-rose-sand-1oevr/",
  "thumb": "/styles/rose-sand-con-waves.jpg",
  "colorDescription": "rose sand: dusty rose pink mixed with sandy blonde, wavy"
 },
 {
  "id": "sand-halo",
  "name": "Sand Halo",
  "kind": "full",
  "refs": [
   "sand-halo-5.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-sand-halo-91xqu/",
  "thumb": "/styles/sand-halo.jpg",
  "colorDescription": "sand halo: sandy beige blonde with light grey strands"
 },
 {
  "id": "sand-halo-con-waves",
  "name": "Sand Halo con Waves",
  "kind": "full",
  "refs": [
   "sand-halo-con-waves-1.jpg",
   "sand-halo-con-waves-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-sand-halo-1oeql/",
  "thumb": "/styles/sand-halo-con-waves.jpg",
  "colorDescription": "sand halo: sandy beige blonde with light grey strands, wavy"
 },
 {
  "id": "golden-tide",
  "name": "Golden Tide",
  "kind": "full",
  "refs": [
   "golden-tide-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-golden-tide-1foz5/",
  "thumb": "/styles/golden-tide.jpg",
  "colorDescription": "golden tide: golden blonde with light brown and a few pale blue-grey strands"
 },
 {
  "id": "golden-tide-con-waves",
  "name": "Golden Tide con Waves",
  "kind": "full",
  "refs": [
   "golden-tide-con-waves-1.jpg",
   "golden-tide-con-waves-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-golden-tide-1tari/",
  "thumb": "/styles/golden-tide-con-waves.jpg",
  "colorDescription": "golden tide: golden blonde with light brown and a few pale blue-grey strands, wavy"
 },
 {
  "id": "moonlit-moss",
  "name": "Moonlit Moss",
  "kind": "full",
  "refs": [
   "moonlit-moss-1.jpg",
   "moonlit-moss-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-moonlit-moss-1ypbn/",
  "thumb": "/styles/moonlit-moss.jpg",
  "colorDescription": "moonlit moss: near-black dark brown with dusty purple and white strands"
 },
 {
  "id": "moonlit-moss-con-waves",
  "name": "Moonlit Moss con Waves",
  "kind": "full",
  "refs": [
   "moonlit-moss-con-waves-1.jpg",
   "moonlit-moss-con-waves-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-moonlit-moss-19j5e/",
  "thumb": "/styles/moonlit-moss-con-waves.jpg",
  "colorDescription": "moonlit moss: near-black dark brown with dusty green and pale blonde strands, wavy"
 },
 {
  "id": "dust-honey",
  "name": "Dust & Honey",
  "kind": "full",
  "refs": [
   "dust-honey-2.jpg",
   "dust-honey-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-dust-honey-n4afa/",
  "thumb": "/styles/dust-honey.jpg",
  "colorDescription": "dust & honey: honey blonde mixed with dusty beige and light brown"
 },
 {
  "id": "dust-honey-con-waves",
  "name": "Dust & Honey con Waves",
  "kind": "full",
  "refs": [
   "dust-honey-con-waves-2.jpg",
   "dust-honey-con-waves-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/dust-honey-cabeza-completa-con-waves-wv6aj/",
  "thumb": "/styles/dust-honey-con-waves.jpg",
  "colorDescription": "dust & honey: honey blonde mixed with dusty beige and light brown, wavy"
 },
 {
  "id": "pumpkin-spice",
  "name": "Pumpkin Spice",
  "kind": "full",
  "refs": [
   "pumpkin-spice-1.jpg",
   "pumpkin-spice-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/sets-pumpkin-spice-iq687/",
  "thumb": "/styles/pumpkin-spice.jpg",
  "colorDescription": "pumpkin spice: warm brown dreadlocks with orange-copper accent strands"
 },
 {
  "id": "pumpkin-spice-con-waves",
  "name": "Pumpkin Spice con Waves",
  "kind": "full",
  "refs": [
   "pumpkin-spice-con-waves-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/sets-pumpkin-spice-cabeza-completa-con-waves-1aglv/",
  "thumb": "/styles/pumpkin-spice-con-waves.jpg",
  "colorDescription": "pumpkin spice: warm orange copper with golden blonde strands, wavy ends"
 },
 {
  "id": "auburn",
  "name": "Auburn",
  "kind": "full",
  "refs": [
   "auburn-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-auburn-1x6rt/",
  "thumb": "/styles/auburn.jpg",
  "colorDescription": "auburn: warm copper-red brown with lighter copper strands"
 },
 {
  "id": "auburn-con-waves",
  "name": "Auburn con Waves",
  "kind": "full",
  "refs": [
   "auburn-con-waves-1.jpg",
   "auburn-con-waves-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-auburn-159at/",
  "thumb": "/styles/auburn-con-waves.jpg",
  "colorDescription": "auburn: warm copper-red brown with lighter copper strands, wavy"
 },
 {
  "id": "cherry-lagoon",
  "name": "Cherry Lagoon",
  "kind": "full",
  "refs": [
   "cherry-lagoon-2.jpg",
   "cherry-lagoon-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-cherry-lagoon-o1grf/",
  "thumb": "/styles/cherry-lagoon.jpg",
  "colorDescription": "cherry lagoon: turquoise and teal blue mixed with brown and cream strands"
 },
 {
  "id": "cherry-lagoon-con-waves",
  "name": "Cherry Lagoon con Waves",
  "kind": "full",
  "refs": [
   "cherry-lagoon-con-waves-1.jpg",
   "cherry-lagoon-con-waves-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-cherry-lagoon-iw4fr/",
  "thumb": "/styles/cherry-lagoon-con-waves.jpg",
  "colorDescription": "cherry lagoon: turquoise and teal blue mixed with brown and cream strands, wavy"
 },
 {
  "id": "terra-lagoon",
  "name": "Terra Lagoon",
  "kind": "full",
  "refs": [
   "terra-lagoon-2.jpg",
   "terra-lagoon-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-terra-lagoon-1behx/",
  "thumb": "/styles/terra-lagoon.jpg",
  "colorDescription": "terra lagoon: warm brown with teal and turquoise strands"
 },
 {
  "id": "terra-lagoon-con-waves",
  "name": "Terra Lagoon con Waves",
  "kind": "full",
  "refs": [
   "terra-lagoon-con-waves-1.jpg",
   "terra-lagoon-con-waves-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-terra-lagoon-s6a4s/",
  "thumb": "/styles/terra-lagoon-con-waves.jpg",
  "colorDescription": "terra lagoon: warm brown with teal and turquoise strands, wavy"
 },
 {
  "id": "honey-brown",
  "name": "Honey Brown",
  "kind": "full",
  "refs": [
   "honey-brown-2.jpg",
   "honey-brown-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-honey-brown-14u3l/",
  "thumb": "/styles/honey-brown.jpg",
  "colorDescription": "honey brown: warm honey and caramel brown"
 },
 {
  "id": "honey-brown-con-waves",
  "name": "Honey Brown con Waves",
  "kind": "full",
  "refs": [
   "honey-brown-con-waves-1.jpg",
   "honey-brown-con-waves-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-honey-brown-1bvet/",
  "thumb": "/styles/honey-brown-con-waves.jpg",
  "colorDescription": "honey brown: warm honey and caramel brown, wavy"
 },
 {
  "id": "golden-rust",
  "name": "Golden Rust",
  "kind": "full",
  "refs": [
   "golden-rust-2.jpg",
   "golden-rust-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-golden-rust-8r9ox/",
  "thumb": "/styles/golden-rust.jpg",
  "colorDescription": "golden rust: warm golden blonde with rust-orange strands"
 },
 {
  "id": "golden-rust-con-waves",
  "name": "Golden Rust con Waves",
  "kind": "full",
  "refs": [
   "golden-rust-con-waves-1.jpg",
   "golden-rust-con-waves-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-golden-rust-l5yup/",
  "thumb": "/styles/golden-rust-con-waves.jpg",
  "colorDescription": "golden rust: warm golden blonde with rust-orange strands, wavy"
 },
 {
  "id": "deep-grove",
  "name": "Deep Grove",
  "kind": "full",
  "refs": [
   "deep-grove-2.jpg",
   "deep-grove-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-deep-grove-1jo6y/",
  "thumb": "/styles/deep-grove.jpg",
  "colorDescription": "deep grove: dark chocolate brown with moss-green and olive strands"
 },
 {
  "id": "deep-grove-con-waves",
  "name": "Deep Grove con Waves",
  "kind": "full",
  "refs": [
   "deep-grove-con-waves-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-deep-grove-mcd2l/",
  "thumb": "/styles/deep-grove-con-waves.jpg",
  "colorDescription": "deep grove: dark chocolate brown with moss-green and olive strands, wavy"
 },
 {
  "id": "night-forest",
  "name": "Night Forest",
  "kind": "full",
  "refs": [
   "night-forest-2.jpg",
   "night-forest-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-night-forest-1arc5/",
  "thumb": "/styles/night-forest.jpg",
  "colorDescription": "night forest: dark brown and black with forest-green strands"
 },
 {
  "id": "night-forest-con-waves",
  "name": "Night Forest con Waves",
  "kind": "full",
  "refs": [
   "night-forest-con-waves-1.jpg",
   "night-forest-con-waves-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-night-forest-10twm/",
  "thumb": "/styles/night-forest-con-waves.jpg",
  "colorDescription": "night forest: dark brown and black with forest-green strands, wavy"
 },
 {
  "id": "moonstone-shadow",
  "name": "Moonstone Shadow",
  "kind": "full",
  "refs": [
   "moonstone-shadow-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-moonstone-shadow-6w24b/",
  "thumb": "/styles/moonstone-shadow.jpg",
  "colorDescription": "moonstone shadow: silver grey mixed with dark grey and black"
 },
 {
  "id": "moonstone-shadow-con-waves",
  "name": "Moonstone Shadow con Waves",
  "kind": "full",
  "refs": [
   "moonstone-shadow-con-waves-1.jpg",
   "moonstone-shadow-con-waves-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-moonstone-shadow-1bpe9/",
  "thumb": "/styles/moonstone-shadow-con-waves.jpg",
  "colorDescription": "moonstone shadow: silver grey mixed with dark grey and black, wavy"
 },
 {
  "id": "moonlit-violet",
  "name": "Moonlit Violet",
  "kind": "full",
  "refs": [
   "moonlit-violet-3.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-moonlit-violet-1qipg/",
  "thumb": "/styles/moonlit-violet.jpg",
  "colorDescription": "moonlit violet: dark brown with violet and purple strands"
 },
 {
  "id": "moonlit-violet-con-waves",
  "name": "Moonlit Violet con Waves",
  "kind": "full",
  "refs": [
   "moonlit-violet-con-waves-1.jpg",
   "moonlit-violet-con-waves-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-con-waves-moonlit-violet-nbt6n/",
  "thumb": "/styles/moonlit-violet-con-waves.jpg",
  "colorDescription": "moonlit violet: dark brown with violet and purple strands, wavy"
 },
 {
  "id": "mulberry-rose",
  "name": "Mulberry Rose",
  "kind": "full",
  "refs": [
   "mulberry-rose-1.jpg",
   "mulberry-rose-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/cabeza-completa-mulberry-rose-6lx0z/",
  "thumb": "/styles/mulberry-rose.jpg",
  "colorDescription": "mulberry rose: deep wine-burgundy with pale dusty pink strands"
 },
 {
  "id": "corona-castano",
  "name": "Corona Castaño",
  "kind": "crown",
  "refs": [
   "corona-castano-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/corona-nro-1-castano-12qgi/",
  "thumb": "/styles/corona-castano.jpg",
  "colorDescription": "medium chestnut brown"
 },
 {
  "id": "corona-castano-oscuro",
  "name": "Corona Castaño oscuro",
  "kind": "crown",
  "refs": [
   "corona-castano-oscuro-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/corona-nro-1-castano-oscuro-v12q0/",
  "thumb": "/styles/corona-castano-oscuro.jpg",
  "colorDescription": "dark espresso brown"
 },
 {
  "id": "corona-rubio-cobrizo",
  "name": "Corona Rubio cobrizo",
  "kind": "crown",
  "refs": [
   "corona-rubio-cobrizo-1.jpg",
   "corona-rubio-cobrizo-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/corona-nro-1-color-rubio-cobrizo-t0oiu/",
  "thumb": "/styles/corona-rubio-cobrizo.jpg",
  "colorDescription": "warm copper blonde"
 },
 {
  "id": "corona-rubio-platinado",
  "name": "Corona Rubio platinado",
  "kind": "crown",
  "refs": [
   "corona-rubio-platinado-1.jpg",
   "corona-rubio-platinado-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/corona-nro-1-color-rubio-platinado-g0rzu/",
  "thumb": "/styles/corona-rubio-platinado.jpg",
  "colorDescription": "pale platinum blonde"
 },
 {
  "id": "corona-negro",
  "name": "Corona Negro",
  "kind": "crown",
  "refs": [
   "corona-negro-2.jpg",
   "corona-negro-4.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/corona-nro-1-negro-1hdw9/",
  "thumb": "/styles/corona-negro.jpg",
  "colorDescription": "jet black"
 },
 {
  "id": "corona-borravino-red-wine",
  "name": "Corona Borravino",
  "kind": "crown",
  "refs": [
   "corona-borravino-red-wine-1.jpg",
   "corona-borravino-red-wine-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/corona-nro-2-borravino-red-wine-1ybqc/",
  "thumb": "/styles/corona-borravino-red-wine.jpg",
  "colorDescription": "deep burgundy wine red"
 },
 {
  "id": "corona-gris-claro-silver-white",
  "name": "Corona Gris claro",
  "kind": "crown",
  "refs": [
   "corona-gris-claro-silver-white-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/corona-nro-2-gris-claro-silver-white-9b81v/",
  "thumb": "/styles/corona-gris-claro-silver-white.jpg",
  "colorDescription": "light silver grey and white"
 },
 {
  "id": "corona-rosa-vintage-rose-ombre",
  "name": "Corona Rosa vintage",
  "kind": "crown",
  "refs": [
   "corona-rosa-vintage-rose-ombre-1.jpg",
   "corona-rosa-vintage-rose-ombre-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/corona-nro-2-rosa-vintage-rose-ombre-1nk7f/",
  "thumb": "/styles/corona-rosa-vintage-rose-ombre.jpg",
  "colorDescription": "vintage rose pink ombré fading to dusty pink"
 },
 {
  "id": "nat-ash-blonde",
  "name": "Ash Blonde",
  "kind": "natural",
  "refs": [
   "nat-ash-blonde-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-ash-blonde/",
  "thumb": "/styles/nat-ash-blonde.jpg",
  "colorDescription": "ash blonde: cool light blonde with grey-beige undertones, no warmth"
 },
 {
  "id": "nat-black-tea",
  "name": "Black Tea",
  "kind": "natural",
  "refs": [
   "nat-black-tea-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-black-tea1/",
  "thumb": "/styles/nat-black-tea.jpg",
  "colorDescription": "black tea: very dark brown, almost black, with warm espresso undertones"
 },
 {
  "id": "nat-caramel",
  "name": "Caramel",
  "kind": "natural",
  "refs": [
   "nat-caramel-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-caramel/",
  "thumb": "/styles/nat-caramel.jpg",
  "colorDescription": "caramel blonde: warm golden honey blonde with lighter sandy strands"
 },
 {
  "id": "nat-caramel-ombre",
  "name": "Caramel Ombre",
  "kind": "natural",
  "refs": [
   "nat-caramel-ombre-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-caramel-ombre/",
  "thumb": "/styles/nat-caramel-ombre.jpg",
  "colorDescription": "caramel ombre: dark brown to black roots fading into warm caramel blonde lengths"
 },
 {
  "id": "nat-cherry-blonde",
  "name": "Cherry Blonde",
  "kind": "natural",
  "refs": [
   "nat-cherry-blonde-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-cherry-blonde/",
  "thumb": "/styles/nat-cherry-blonde.jpg",
  "colorDescription": "cherry blonde: warm copper-red strawberry blonde with ginger tones"
 },
 {
  "id": "nat-cocoa",
  "name": "Cocoa",
  "kind": "natural",
  "refs": [
   "nat-cocoa-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-cocoa/",
  "thumb": "/styles/nat-cocoa.jpg",
  "colorDescription": "cocoa: medium chestnut brown with soft copper-red glints"
 },
 {
  "id": "nat-endless-summer",
  "name": "Endless Summer",
  "kind": "natural",
  "refs": [
   "nat-endless-summer-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-endless-summer/",
  "thumb": "/styles/nat-endless-summer.jpg",
  "colorDescription": "endless summer: pale platinum blonde with warm sandy roots and cream strands"
 },
 {
  "id": "nat-ice-baby",
  "name": "Ice Baby",
  "kind": "natural",
  "refs": [
   "nat-ice-baby-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-ice-baby/",
  "thumb": "/styles/nat-ice-baby.jpg",
  "colorDescription": "ice baby: icy white platinum lengths with jet black roots"
 },
 {
  "id": "nat-jet-black",
  "name": "Jet Black",
  "kind": "natural",
  "refs": [
   "nat-jet-black-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-jet-black/",
  "thumb": "/styles/nat-jet-black.jpg",
  "colorDescription": "jet black: deep uniform black with a matte finish"
 },
 {
  "id": "nat-morning-coffee",
  "name": "Morning Coffee",
  "kind": "natural",
  "refs": [
   "nat-morning-coffee-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-morning-coffee1/",
  "thumb": "/styles/nat-morning-coffee.jpg",
  "colorDescription": "morning coffee: medium warm brown, like milky coffee"
 },
 {
  "id": "nat-red-wine",
  "name": "Red Wine",
  "kind": "natural",
  "refs": [
   "nat-red-wine-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-red-wine/",
  "thumb": "/styles/nat-red-wine.jpg",
  "colorDescription": "red wine: deep burgundy wine red with dark cherry undertones"
 },
 {
  "id": "nat-silver-white",
  "name": "Silver White",
  "kind": "natural",
  "refs": [
   "nat-silver-white-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-silver-white/",
  "thumb": "/styles/nat-silver-white.jpg",
  "colorDescription": "silver white: light silver grey with white and pale blue-grey strands"
 },
 {
  "id": "nat-space-gray",
  "name": "Space Gray",
  "kind": "natural",
  "refs": [
   "nat-space-gray-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-space-gray/",
  "thumb": "/styles/nat-space-gray.jpg",
  "colorDescription": "space gray: silver grey lengths with black roots"
 },
 {
  "id": "nat-summer-ombre-1",
  "name": "Summer Ombre 1",
  "kind": "natural",
  "refs": [
   "nat-summer-ombre-1-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-summer-ombre-1/",
  "thumb": "/styles/nat-summer-ombre-1.jpg",
  "colorDescription": "summer ombre: pale platinum blonde lengths with deep chocolate-brown roots — warm dark brown, NOT copper or orange-toned"
 },
 {
  "id": "nat-summer-ombre-2",
  "name": "Summer Ombre 2",
  "kind": "natural",
  "refs": [
   "nat-summer-ombre-2-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-summer-ombre-2/",
  "thumb": "/styles/nat-summer-ombre-2.jpg",
  "colorDescription": "summer ombre: platinum blonde lengths with black roots"
 },
 {
  "id": "wavy-blanco-y-gris-claro",
  "name": "Blanco y gris claro",
  "kind": "wavy",
  "refs": [
   "wavy-blanco-y-gris-claro-1.jpg",
   "wavy-blanco-y-gris-claro-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/dreadlocks-onduladas-banco-y-gris-claro-5-rastas-1bovs/",
  "thumb": "/styles/wavy-blanco-y-gris-claro.jpg",
  "colorDescription": "white and light grey: pale silver-white wavy dreadlocks"
 },
 {
  "id": "wavy-rubio-platinado",
  "name": "Rubio platinado",
  "kind": "wavy",
  "refs": [
   "wavy-rubio-platinado-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/dreadlocks-onduladas-rubio-platinado-5-rastas-8y19i/",
  "thumb": "/styles/wavy-rubio-platinado.jpg",
  "colorDescription": "platinum blonde: pale cool blonde wavy dreadlocks"
 },
 {
  "id": "wavy-rubio-claro",
  "name": "Rubio claro",
  "kind": "wavy",
  "refs": [
   "wavy-rubio-claro-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-dreadlocks-rubio-cobrizo-h7l84/",
  "thumb": "/styles/wavy-rubio-claro.jpg",
  "colorDescription": "light blonde: warm golden honey-blonde wavy dreadlocks, darker and warmer than rubio platinado"
 },
 {
  "id": "wavy-castano-claro",
  "name": "Castaño claro",
  "kind": "wavy",
  "refs": [
   "wavy-castano-claro-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/dreadlocks-onduladas-rubio-platinado-5-rastas-8y19i/",
  "thumb": "/styles/wavy-castano-claro.jpg",
  "colorDescription": "light chestnut brown: warm medium-brown wavy dreadlocks, darker and browner than rubio claro and rubio cobrizo"
 },
 {
  "id": "wavy-casta-o-oscuro-y-negro",
  "name": "Castaño oscuro y negro",
  "kind": "wavy",
  "refs": [
   "wavy-casta-o-oscuro-y-negro-1.jpg",
   "wavy-casta-o-oscuro-y-negro-2.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-de-dreadlocks-castano-oscuro-y-negro-1uu6i/",
  "thumb": "/styles/wavy-casta-o-oscuro-y-negro.jpg",
  "colorDescription": "dark brown and black: deep espresso brown mixed with black wavy dreadlocks"
 },
 {
  "id": "wavy-rubio-cobrizo",
  "name": "Rubio cobrizo",
  "kind": "wavy",
  "refs": [
   "wavy-rubio-cobrizo-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-de-dreadlocks-rubio-conbrizo-5-rastas-19eku/",
  "thumb": "/styles/wavy-rubio-cobrizo.jpg",
  "colorDescription": "copper blonde: warm copper-bronze blonde wavy dreadlocks, darker and more coppery than rubio claro"
 },
 {
  "id": "ash-platinum",
  "name": "Ash Platinum",
  "kind": "waves",
  "refs": [
   "ash-platinum-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-ash-platinum-70cms/",
  "thumb": "/styles/ash-platinum.jpg",
  "colorDescription": "ash platinum: warm-toned blonde ombre, NOT cool or icy or grey — warm ash blonde at the root transitioning to warm platinum blonde at the tips"
 },
 {
  "id": "ash-blonde",
  "name": "Ash Blonde",
  "kind": "waves",
  "refs": [
   "ash-blonde-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-ash-blonde-55-cms-pdv3b/",
  "thumb": "/styles/ash-blonde.jpg",
  "colorDescription": "ash blonde: cool, ashy blonde with grey-beige undertones — NOT warm, golden or honey-toned. Muted cool blonde base mixed with lighter ash-blonde strands; the overall impression must read as ceniza (ash/cool), never as a warm honey or golden blonde"
 },
 {
  "id": "light-blonde",
  "name": "Light Blonde",
  "kind": "waves",
  "refs": [
   "light-blonde-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-light-blonde-70cms/",
  "thumb": "/styles/light-blonde.jpg",
  "colorDescription": "light blonde: very pale champagne blonde with soft warm undertones, lighter and creamier than ash platinum"
 },
 {
  "id": "linen",
  "name": "Linen",
  "kind": "waves",
  "refs": [
   "linen-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-linen-70cms-mvkus/",
  "thumb": "/styles/linen.jpg",
  "colorDescription": "linen: dark ombre, NOT a light blonde overall — medium-dark ashy brown-taupe roots covering most of the length, transitioning only near the very ends to a muted light beige-blonde. The overall impression must read as a noticeably dark, muted, greyish-brown colour, not a light or pale one"
 },
 {
  "id": "cherry-blonde",
  "name": "Cherry Blonde",
  "kind": "waves",
  "refs": [
   "cherry-blonde-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-cherry-blonde-70cms/",
  "thumb": "/styles/cherry-blonde.jpg",
  "colorDescription": "cherry blonde: warm caramel-copper blonde with reddish-auburn undertones mixed with lighter honey-blonde highlights, warmer and darker than the other Waves colours"
 },
 {
  "id": "coconut",
  "name": "Coconut",
  "kind": "waves",
  "refs": [
   "coconut-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-coconut-70cms-1yn7l/",
  "thumb": "/styles/coconut.jpg",
  "colorDescription": "coconut: warm solid copper-auburn ginger tone, fairly uniform colour with little highlight variation, less multi-toned than cherry blonde"
 },
 {
  "id": "ginger",
  "name": "Ginger",
  "kind": "waves",
  "refs": [
   "ginger-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-ginger-70cms/",
  "thumb": "/styles/ginger.jpg",
  "colorDescription": "ginger: vivid bright orange-red ginger tone, more saturated and vibrant than coconut or cherry blonde"
 },
 {
  "id": "ginger-cherry",
  "name": "Ginger Cherry",
  "kind": "waves",
  "refs": [
   "ginger-cherry-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-ginger-cherry-70cms-8oc0l/",
  "thumb": "/styles/ginger-cherry.jpg",
  "colorDescription": "ginger cherry: deep red-burgundy tone with pink undertones, darker and more vivid red than ginger, redder than cherry blonde"
 },
 {
  "id": "red-wine",
  "name": "Red Wine",
  "kind": "waves",
  "refs": [
   "red-wine-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-red-wine-70cms-p1ipr/",
  "thumb": "/styles/red-wine.jpg",
  "colorDescription": "red wine: vivid magenta-pink fashion colour with deep wine-purple undertones in the shadows, distinct from the natural red-orange tones of ginger and ginger cherry"
 },
 {
  "id": "morning-coffee",
  "name": "Morning Coffee",
  "kind": "waves",
  "refs": [
   "morning-coffee-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-morning-coffee-70cms/",
  "thumb": "/styles/morning-coffee.jpg",
  "colorDescription": "morning coffee: deep dark brown, almost black, with warm coffee-brown undertones"
 },
 {
  "id": "jet-black",
  "name": "Jet Black",
  "kind": "waves",
  "refs": [
   "jet-black-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-jet-black-70cms/",
  "thumb": "/styles/jet-black.jpg",
  "colorDescription": "jet black: solid true black, no brown undertones, darker and more neutral than morning coffee"
 },
 {
  "id": "light-grey",
  "name": "Light Grey",
  "kind": "waves",
  "refs": [
   "light-grey-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-light-gray-70cms/",
  "thumb": "/styles/light-grey.jpg",
  "colorDescription": "light grey: cool light silver-grey with a subtle mauve undertone, a true grey rather than a blonde tone, distinct from ash platinum and linen"
 },
 {
  "id": "green-aqua",
  "name": "Green Aqua",
  "kind": "waves",
  "refs": [
   "green-aqua-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-green-aqua-70cms-yydsh/",
  "thumb": "/styles/green-aqua.jpg",
  "colorDescription": "green aqua: vivid bright teal-green fantasy colour, saturated and uniform"
 },
 {
  "id": "pink",
  "name": "Pink",
  "kind": "waves",
  "refs": [
   "pink-1.jpg"
  ],
  "productUrl": "https://www.dreadlovearg.com/productos/pack-waves-pink-blondes-70cms-kgnxl/",
  "thumb": "/styles/pink.jpg",
  "colorDescription": "pink: pale blonde mixed with soft pastel pink strands throughout"
 }
]
